<nav>
	<section>
		<lvr-sidebar-button icon="home" [label]="'sidebar.overview' | transloco" [route]="['/']"></lvr-sidebar-button>
		<lvr-sidebar-button
			icon="list"
			[label]="'sidebar.database' | transloco"
			[route]="['/database']"
		></lvr-sidebar-button>
		<lvr-sidebar-button
			icon="desktop_windows"
			[label]="'sidebar.desk' | transloco"
			[route]="['/desk']"
		></lvr-sidebar-button>
	</section>
	<mat-divider></mat-divider>
	<section>
		<ng-content></ng-content>
	</section>
	<mat-divider></mat-divider>
	<ng-content select="temp-entries"></ng-content>
	<mat-divider class="bottom"></mat-divider>
	<section class="bottom">
		<lvr-sidebar-help-menu></lvr-sidebar-help-menu>
		<lvr-sidebar-settings-menu
			[canReceiveRepresentation]="canReceiveRepresentation()"
			[representations]="representations()"
			[representationsLoading]="representationsLoading()"
			(loadRepresentations)="loadRepresentations()"
			(selectRepresentative)="selectRepresentative($event)"
			(logout)="logout()"
		></lvr-sidebar-settings-menu>
	</section>
</nav>
